import { useState, useEffect } from "react";

function getOrientation() {
  if (typeof window === "undefined") return "landscape";
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
}

function getWidth() {
  if (typeof window === "undefined") return 1920;
  return window.innerWidth;
}

export function useCols() {
  const [cols, setCols] = useState(() => computeCols(getWidth(), getOrientation()));

  useEffect(() => {
    function handleResize() {
      setCols(computeCols(getWidth(), getOrientation()));
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return cols;
}

function computeCols(w, orientation) {
  if (orientation === "landscape") {
    if (w < 600) return 4;
    if (w < 900) return 6;
    if (w < 1200) return 8;
    if (w < 1600) return 10;
    if (w < 2000) return 12;
    return 14;
  }
  if (w < 360) return 2;
  if (w < 480) return 3;
  if (w < 600) return 4;
  if (w < 840) return 5;
  if (w < 1200) return 6;
  return 7;
}

export function useIsLandscape() {
  const [isLandscape, setIsLandscape] = useState(() => getOrientation() === "landscape");

  useEffect(() => {
    function handleResize() {
      setIsLandscape(getOrientation() === "landscape");
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isLandscape;
}
